import React from "react";
import ContributionCalculator from "../shared-cost-application/modal/ContributionCalculator";

const CalculatorView = () => {
  return <ContributionCalculator />;
};

export default CalculatorView;
